import styled, {css} from 'styled-components';
import {mt} from '@nib/layout';
import Copy, {CopyProps} from '@nib-components/copy';
import {formHelpTextColor, formHelpTextSize} from '@nib-components/theme';
import {disabledOpacity} from '../disabled';

export interface HelpProps extends CopyProps {
  disabled?: boolean;
}
const Help = styled(Copy).attrs({component: 'div'})<HelpProps>`
  ${mt(1)};
  color: ${formHelpTextColor};
  font-size: ${formHelpTextSize};
  line-height: 1.5;

  ${({disabled}) =>
    disabled &&
    css`
      opacity: ${disabledOpacity};
    `};
`;

Help.displayName = 'Help';

export default Help;
